import React from "react";
import { ISearchableChecklistItem } from "../../../yoello-lib/modules/components/UI/Lists/SearchableChecklist/SearchableChecklistItem";
import { IPlacedOrder, IProcessedOrdersDetails, OrderOptions } from "../constants";
import { refundReasonObj, refundDialogButton, RefundTitles, RefundReasons, RefundActionType } from "./types";
import { contentMarkup } from "./OrderDetailsChecklistDialog";
import { IDialogHandleState } from "../../../reducers/dialog";
export function onIssueRefund(
  key: string,
  dialogKey:string,
  path: string,
  placed_order: IPlacedOrder,
  goToNextStep: any,
  goToPrevStep: (currentKey: string) => void,
  refundReasons: refundReasonObj[],
  submitButton: refundDialogButton,
  title: string,
  dialogTitle: string,
  orderDetails: IProcessedOrdersDetails,
  infoCard?: {
    title: string,
    content: string
  },
  totalRefundedPrice?: number
) {
  goToNextStep(dialogKey, {
    ComponentProps: {
      orderDetails: orderDetails,
      placedOrder: placed_order,
      refundReasons,
      submitButton,
      title,
      infoCard,
      totalRefundedPrice: totalRefundedPrice,
      path
    },
    isFormDialog: false,
    dialogTitle
  }, path, key)
}
export const refundTitles: Record<string, RefundTitles> = {
  [RefundActionType.REFUND]: {
    ConfirmButtonLabel: "PartialReafund.OrderHistory.Decline.ConfirmButton",
    ConfirmButtonColor: "#FA7800",
    Title: "PartialReafund.OrderHistory.Decline.Title",
    DialogTitle: "PartialReafund.OrderHistory.Decline.DialogTitle",
    InfoCardTitle: "PartialReafund.OrderHistory.Decline.InfoCard.Title",
    InfoCardContent: "PartialReafund.OrderHistory.Decline.InfoCard.Content",
    SpecificItemsDialogTitle: "PartialReafund.OrderHistory.SpecificItemsDialogTitle",
    SpecificItemsDialogLabel: "PartialReafund.OrderHistory.SpecificItemsDialogLabel"
  },
  [RefundActionType.DECLINE]: {
    ConfirmButtonLabel: "PartialReafund.NewOpenOrders.ConfirmButton",
    ConfirmButtonColor: "#FB0F2A",
    Title: "PartialReafund.NewOpenOrders.Title",
    DialogTitle: "PartialReafund.NewOpenOrders.DialogTitle",
    InfoCardTitle: "PartialReafund.NewOpenOrders.InfoCard.Title",
    InfoCardContent: "PartialReafund.NewOpenOrders.InfoCard.Content",
    SpecificItemsDialogTitle: "PartialReafund.NewOpenOrders.SpecificItemsDialogTitle",
    SpecificItemsDialogLabel: "PartialReafund.NewOpenOrders.SpecificItemsDialogLabel",
  }
}

export function getPlacedOrderDetails(placedOrder: IPlacedOrder) {
  const { placed_order_order_service_charge, placed_order_order_gratuity, placed_order_order_processing_charge } = placedOrder;
  return [
    {
      id: "Delivery_Charge",
      title: "Delivery Charge",
      value: placed_order_order_service_charge,
      enabled: placed_order_order_service_charge ? true : false,
    },
    {
      id: "Service_Charge",
      title: "Service Charge",
      value: placed_order_order_processing_charge,
      enabled: placed_order_order_processing_charge ? true : false
    },
    {
      id: "Tip",
      title: "Tip",
      value: placed_order_order_gratuity,
      enabled: placed_order_order_gratuity ? true : false
    },
  ];
}

export function createSpecificItemsCheckListArray(placedOrder: IPlacedOrder, selectedItems: ISearchableChecklistItem[], classes: any) {
  const placedOrderDetails = getPlacedOrderDetails(placedOrder);
  const items: ISearchableChecklistItem[] = [];
  placedOrderDetails.forEach((item: { id: string, title: string, enabled: boolean }) => {
    if (item.enabled) {
      items.push({
        id: item.id,
        selected: selectedItems && !!selectedItems.filter((selectedItem: ISearchableChecklistItem) => {
          return selectedItem.id === item.id;
        }).length,
        keywords: item.title,
        content: contentMarkup(item.title, classes.ItemContentWrapper),
        disabled: false,
        errors: [],
        name_public: item.title,
        name_internal: item.title,
      })
    }
  });
  return items
}


export const reasons: refundReasonObj[] = [
  {
    key: RefundReasons.STOCK,
    title: "PartialReafund.OrderHistory.Decline.Reasons.Stock",
    hasInfo: true,
    hide:false
  },
  {
    key: RefundReasons.DISSATISFACTION,
    title: "PartialReafund.OrderHistory.Decline.Reasons.CustomerDisSatisfaction",
    hide:false
  },
  {
    key: RefundReasons.OTHER,
    title: "PartialReafund.OrderHistory.Decline.Reasons.Other",
    hide:false
  }
]


export function openReasonsDialog(key: string,dialogKey:string, path: string, isRefund: boolean, placed_order: IPlacedOrder, t: (key: string) => string,
  goToNextStep: (key: string, dialogState: Partial<IDialogHandleState<any>>, path: string, prevKey?: string | null) => void, goToPrevStep: (prevKey: string) => void, OrderDetails: IProcessedOrdersDetails, Icon?: React.ReactNode, totalRefundedPrice?: number,isPAY360Venue?:boolean) {
  const { ConfirmButtonLabel, ConfirmButtonColor, Title, DialogTitle, InfoCardTitle, InfoCardContent } = refundTitles[isRefund ? RefundActionType.REFUND : RefundActionType.DECLINE];
  if(isRefund) {reasons[0].hide=true} else {reasons[0].hide=false}
  onIssueRefund(key,dialogKey,path, placed_order, goToNextStep, goToPrevStep, reasons, {
    label: t(ConfirmButtonLabel),
    color: t(ConfirmButtonColor),
    labelColor: "#FFFFFF",
    Icon: isRefund ? Icon : undefined,
  },
    t(Title),
    t(DialogTitle),
    OrderDetails,
    (isPAY360Venue || OrderDetails?.placed_order?.placed_order_order_option === OrderOptions.ORDER_ONLY)?undefined:{
      title: t(InfoCardTitle),
      content: t(InfoCardContent),
    }, totalRefundedPrice);
}